import './copyButton.css'
import { toast, ToastContainer } from 'react-toastify'

export const CopyButton = ({ text }) => {
 

  const copyToClipboard = () => {
    navigator.clipboard.writeText(text)
    toast.success('Email copiado',{
      autoClose:2000
    })
    
  }

  return (
    <div className='copy-btn-container'>
      {/* <ToastContainer /> */}
      <span
        className="material-icons notranslate mIcons-1 mI-2 ms-2 modal-copy-button cursor-pointer"
        onClick={copyToClipboard}
      >content_copy</span>
    </div>
  )
}